// src/Components/Email/EmailClient.js
import React, { useEffect, useState } from 'react';
import EmailSidebar from './EmailSidebar';
import EmailList from './EmailList';
import EmailViewer from './EmailViewer';
import EmailComposer from './EmailComposer';
import { useSelector, useDispatch } from 'react-redux';
import { fetchEmails } from '../../slices/emailSlice';

const EmailClient = () => {
  const dispatch = useDispatch();
  const { mailbox, selectedEmail, replyMode } = useSelector((state) => state.emails);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [composing, setComposing] = useState(false);

  useEffect(() => {
    dispatch(fetchEmails({ mailbox }));
  }, [dispatch, mailbox]);



  return (
    <div style={{ display: 'flex', flex: 1, height: '100vh', position: 'relative' }}>
      {replyMode !== 'compose' && 
      <>
      <button
        onClick={() => setDrawerOpen((prev) => !prev)}
        className="hamburger-menu"
        style={{ position: 'absolute', top: -1, left: -20, zIndex: 1000 }}
      >
        ☰
      </button>
      <div
        className="email-sidebar-wrapper"
        style={{
          flex: 1,
          transform: drawerOpen ? 'translateX(0)' : 'translateX(-96%)',
          transition: 'transform 0.3s ease',
          width: 250,
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          minHeight: 500,
          backgroundColor: '#f8f8f8',
          zIndex: 999,
          boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
        }}
      >
        <EmailSidebar/>
      </div>
      </>
    }

      <div style={{ display: 'flex', flex: 1, flexDirection: 'column', width: '100%', marginLeft: drawerOpen ? 260 : 10 }}>
        {replyMode === 'compose' ? (
          <EmailComposer />
        ) : selectedEmail ? (
          <EmailViewer />
        ) : (
          <EmailList key={`mailbox-${mailbox}-${selectedEmail?.id || Date.now()}`}/>
        )}
      </div>
    </div>
  );
};

export default EmailClient;